import { action, makeObservable, observable, reaction } from 'mobx';
import { RiskType, linesCountByRowType, plinkoRowType, BALL_COUNT } from '../plinkoCore/enums';
import { plinkoGameService } from '../plinkoService/gameService';
import { userInfoStore } from '../../../store/userInfoStore';
import { parseNumberByPrecision } from '../../../core/helpers/parseNumberByPrecision';
import { freeBetStore } from '../../../store/freeBetStore';

class PlinkoBetsStore {
  isBetsClosed = false;

  isAllowedNextBet = true;

  isFpsLow = false;

  isHaveCirclesInPlinko = false;

  rowType = plinkoRowType._10;

  linesCount = linesCountByRowType[this.rowType];

  riskType = RiskType.medium;

  ballCount = BALL_COUNT._1;

  oddsAndIndexes = null;

  fps = 0;

  lastResults = [];

  roundResult = {
    winAmount: null,
    winOdd: null,
  };

  totalBetAmount = null;

  constructor() {
    makeObservable(this, {
      fps: observable,
      rowType: observable,
      riskType: observable,
      isFpsLow: observable,
      roundResult: observable.deep,
      ballCount: observable,
      linesCount: observable,
      lastResults: observable,
      isBetsClosed: observable,
      totalBetAmount: observable,
      oddsAndIndexes: observable,
      isAllowedNextBet: observable,
      isHaveCirclesInPlinko: observable,
      setFps: action.bound,
      resetStore: action.bound,
      setRowType: action.bound,
      setIsFpsLow: action.bound,
      setRiskType: action.bound,
      setBallCount: action.bound,
      setLastResults: action.bound,
      setRoundResult: action.bound,
      setIsBetsClosed: action.bound,
      setTotalBetAmount: action.bound,
      updateLastResults: action.bound,
      setOddsAndIndexes: action.bound,
      setIsAllowedNextBet: action.bound,
      setIsHaveCirclesInPlinko: action.bound,
    });

    reaction(
      () => this.isHaveCirclesInPlinko,
      (value) => {
        const { setIsAllowedChangeCurrency } = userInfoStore;
        setIsAllowedChangeCurrency(!value);
        if (freeBetStore.currentFreeBet && !freeBetStore.currentFreeBet.remainingCount && !value) {
          freeBetStore.setIsShowFreeBetPopup(true);
        }
      }
    );

    reaction(
      () => userInfoStore.betAmount,
      (value, prev) => {
        if (prev !== value) {
          this.setTotalBetAmount(
            parseNumberByPrecision(value, this.ballCount, userInfoStore.precision)
          );
        }
      }
    );
    reaction(
      () => this.ballCount,
      () => {
        userInfoStore.setTotalBetAmount(this.ballCount * userInfoStore.betAmount);
      }
    );
  }

  setTotalBetAmount(amount) {
    this.totalBetAmount = amount;
  }

  setIsAllowedNextBet(value) {
    this.isAllowedNextBet = value;
  }

  setLastResults(lastResults) {
    this.lastResults = lastResults.map((item, index) => ({ ...item, id: index }));
  }

  setRoundResult(result) {
    this.roundResult = result;
  }

  resetRoundResult() {
    this.roundResult = {
      winAmount: null,
      winOdd: null,
    };
  }

  updateLastResults(lastResult) {
    const updatedLastResult = [lastResult, ...this.lastResults];
    this.setLastResults(updatedLastResult.splice(0, 10));
  }

  setIsFpsLow(bool) {
    this.isFpsLow = bool;
  }

  setFps(fps) {
    // if (fps < 10 && this.isFpsLow && this.isHaveCirclesInPlinko) {
    //   plinkoGameService.connectionLostHandler();
    //   gameDrawer.removeAllMainBalls();
    // }
    this.fps = fps;
    if (fps > 30 && this.isFpsLow) {
      this.setIsFpsLow(false);
    } else if (fps < 30) {
      this.setIsFpsLow(true);
    }
  }

  setRowType(rowType) {
    this.rowType = rowType;
    this.linesCount = linesCountByRowType[rowType];
    plinkoGameService.changeHash();
  }

  setBallCount(count) {
    this.ballCount = count;
    this.setTotalBetAmount(
      parseNumberByPrecision(userInfoStore.betAmount, count, userInfoStore.precision)
    );
    plinkoGameService.changeHash();
  }

  setRiskType(riskType) {
    this.riskType = riskType;
    plinkoGameService.changeHash();
  }

  setOddsAndIndexes(oddsAndIndexes) {
    this.oddsAndIndexes = oddsAndIndexes;
  }

  setIsHaveCirclesInPlinko(bool) {
    this.isHaveCirclesInPlinko = bool;
  }

  setIsBetsClosed(bool) {
    this.isBetsClosed = bool;
  }

  getOddsArray() {
    if (!this.oddsAndIndexes) {
      return [];
    }
    return Object.values(
      Object.values(Object.values(this.oddsAndIndexes)[this.rowType])[this.riskType]
    );
  }

  resetStore() {
    this.isBetsClosed = false;
    this.isAllowedNextBet = true;
    this.isFpsLow = false;
    this.isHaveCirclesInPlinko = false;
    this.oddsAndIndexes = null;
    this.fps = 0;
    this.lastResults = [];
    this.roundResult = {
      winAmount: null,
      winOdd: null,
    };
    this.totalBetAmount = null;
  }
}

export const plinkoBetsStore = new PlinkoBetsStore();
